var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36006_168218)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.5C17 13.2104 13.2104 17 8.5 17C3.78956 17 0 13.2104 0 8.5C0 3.78956 3.78956 0 8.5 0C13.2104 0 17 3.78956 17 8.5ZM12.4787 6.60666V5.09998H4.52167V6.60666H7.50854V7.65129C5.41076 7.76292 3.83694 8.22143 3.82528 8.77099L3.8252 9.91665C3.83687 10.4662 5.41076 10.9247 7.50854 11.0363V13.6H9.49187V11.0363C11.5896 10.9247 13.1635 10.4662 13.1751 9.91665L13.1752 8.77099C13.1635 8.22143 11.5896 7.76292 9.49187 7.65129V6.60666H12.4787ZM13.0702 9.34358C12.6122 9.86133 10.7411 10.249 8.50238 10.249C6.26367 10.249 4.39251 9.86133 3.93457 9.34358C4.3229 8.90454 5.7275 8.55901 7.51071 8.46411V9.55784C7.83032 9.57485 8.1621 9.58381 8.50238 9.58381C8.84264 9.58381 9.17442 9.57485 9.49404 9.55784V8.46411C11.2772 8.55901 12.6818 8.90454 13.0702 9.34358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36006_168218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.45b80fc0e4e396cbbe5546314c597911.svg";
export { ForwardRef as ReactComponent };